import { motion } from 'framer-motion';

/**
 * Scroll-into-view reveal. Fades + slides its children up the first time they
 * enter the viewport. Respects prefers-reduced-motion automatically (framer
 * disables transforms when the OS setting is on).
 *
 *   <Reveal><h2>Title</h2></Reveal>
 *   <Reveal delay={0.1} y={32}>...</Reveal>
 */
function Reveal({
    children,
    className,
    delay = 0,
    y = 28,
    duration = 0.6,
    once = true,
    amount = 0.2,
}) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount }}
            transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    );
}

export default Reveal;
